import React from "react";
import { Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import { MdContacts } from "react-icons/md";
import Card from "horizon/components/card/Card";

/**
 * Builds the dynamic subtitle text for the header card.
 * @param {number} count - Items on the current view
 * @param {boolean} searchActive - Whether the user is currently searching
 * @returns {string}
 */
function buildSubtitle(count, searchActive) {
  if (searchActive) {
    if (count === 0) return "Aucun résultat";
    return `${count} résultat${count > 1 ? "s" : ""} de recherche`;
  }
  if (count === 0) return "Aucun contact à afficher";
  return `${count} contact${count > 1 ? "s" : ""} affiché${count > 1 ? "s" : ""} (page courante)`;
}

/**
 * Renders the page header card with icon, title and subtitle.
 * @param {Object} props - count (number), searchActive (boolean)
 * @returns {React.ReactElement}
 */
function ContactCardsHeader({ count, searchActive }) {
  const titleColor = useColorModeValue("secondaryGray.900", "white");
  const subColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
  const badgeBg = useColorModeValue("brand.100", "whiteAlpha.100");
  return (
    <Card>
      <Flex align="center" gap="14px" minW="0">
        <Flex align="center" justify="center" w="44px" h="44px" borderRadius="12px" bg={badgeBg}>
          <Icon as={MdContacts} w="22px" h="22px" color="brand.500" />
        </Flex>
        <Flex direction="column" minW="0">
          <Text fontSize="lg" fontWeight="700" color={titleColor}>Contacts</Text>
          <Text fontSize="sm" color={subColor} noOfLines={1}>{buildSubtitle(count, searchActive)}</Text>
        </Flex>
      </Flex>
    </Card>
  );
}

export default ContactCardsHeader;
